import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconTemplate = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 90 90",
	fill: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 90.433,
				height: 21.923,
				rx: 5.481
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 49.327,
				y: 30.144,
				width: 41.106,
				height: 24.663,
				rx: 5.481
			}),
			/* @__PURE__ */ _jsx("rect", {
				y: 30.144,
				width: 41.106,
				height: 60.288,
				rx: 5.481
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 49.327,
				y: 63.029,
				width: 41.106,
				height: 27.404,
				rx: 5.481
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", { d: "M0 0h90v90H0z" })
	}) })]
});
export default SvgIconTemplate;
